import { post, get, put, deleteApi } from './axiosFun';
//档案分页
export const archivePage = (params) => { return post("/sys/sys-archive/archivePage", params) };
//档案新增
export const archiveAdd = (params) => { return post("/sys/sys-archive/archiveAdd", params) };
//档案编辑
export const archiveEdit = (params) => { return put("/sys/sys-archive/archiveEdit", params) };
//档案详情
export const archiveDetail = (archiveId) => { return get(`/sys/sys-archive/archiveDetail/${archiveId}`) };
//导入结果查询
export const importRes = () => { return get(`/sys/sys-archive/importRes`) };
//档案删除
export const archiveRemove = (params) => { return deleteApi(`/sys/sys-archive/archiveRemove`,params) };
//档案列表
export const archiveList = (params) => { return post(`/sys/sys-archive/archiveList`,params) };
export const archiveBaseList = (params) => { return post(`/sys/sys-archive/archiveBaseList`,params) };
export const archiveInfoExport = (archiveId) => { return get(`/sys/sys-archive/archiveInfo/${archiveId}`) };
//我的培训记录
export const trainRecQuery = (params) => { return post(`train/study-rec/trainRecQuery`,params) };
export const exportTrainRec = (params,header) => { return post(`train/study-rec/exportTrainRec`,params,header) };



// WEBPACK FOOTER //
// ./src/api/employee.js